/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Integration_AnswerInputs */

const en_faq_integration_answer = /** @type {(inputs: Faq_Integration_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually, yes. We connect AI and large language models to the tools you already use, such as Gmail or Microsoft 365, Slack, HubSpot and other CRMs, Google Sheets, databases and internal applications, through their APIs. We check what can connect during discovery, before proposing a system.`)
};

const lv_faq_integration_answer = /** @type {(inputs: Faq_Integration_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parasti jā. Mēs savienojam AI un lielos valodas modeļus ar rīkiem, ko jau izmantojat, piemēram, Gmail vai Microsoft 365, Slack, HubSpot un citām CRM, Google Sheets, datubāzēm un iekšējām lietotnēm, izmantojot to API. Ko var savienot, pārbaudām izpētes laikā, pirms piedāvājam sistēmu.`)
};

/**
* | output |
* | --- |
* | "Usually, yes. We connect AI and large language models to the tools you already use, such as Gmail or Microsoft 365, Slack, HubSpot and other CRMs, Google She..." |
*
* @param {Faq_Integration_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_integration_answer = /** @type {((inputs?: Faq_Integration_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Integration_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_integration_answer(inputs)
	return en_faq_integration_answer(inputs)
});